import type { OrderDetails as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';
import * as Customer from '../Customer/Customer';
import { toOrderState } from './OrderState';
import type { OrderState } from './OrderState';

/**
 * The internal schema's `OrderDetails` type.
 *
 * Structurally close to `App/Order/OrderDetail` but not the same type, and deliberately so: the two
 * schemas are independent, and this one carries neither `account` nor `ticketLayout`. As elsewhere in
 * this namespace, only the fields something asks for are mapped — see `Order.ts`.
 */
export type OrderDetail = {
  id: number;
  state: OrderState;
  fingerprint: string;
  transactionId?: string;
  customer?: Customer.Customer;
};

export const fromGql = (item: GQLItem): OrderDetail => ({
  ...take<OrderDetail>(item, 'id', 'fingerprint', 'transactionId'),
  state: toOrderState(item.state),
  customer: item.customer ? Customer.fromGql(item.customer) : undefined,
});
